module.exports = __webpack_public_path__ + "static/media/regalo.22df608e.png";